<template>
  <div class="loader-wrapper" :class="{active: visible}">
    <slot></slot>
    <div v-if="visible" class="d-flex justify-content-center loader-container" style="z-index: 1000"
         :style="{'background-color': backgroundColorValue}">
      <div class="spinner-border" role="status" :style="{'zoom': zoomValue}">
        <span class="visually-hidden"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';

export default defineComponent({
  props: {
    backgroundColor: String,
    zoom: Number
  },
  setup(props) {

    const state = reactive({
      visible: false
    });

    const backgroundColorValue = computed(() => props.backgroundColor ?? 'rgb(240 241 243 / 73%)')
    const zoomValue = computed(() => props.zoom ?? 1)

    const show = () => {
      state.visible = true;
    }

    const hide = () => {
      state.visible = false;
    }

    return {
      ...toRefs(state),
      backgroundColorValue,
      zoomValue,
      show,
      hide
    }
  }
})
</script>
